export default "__VITE_PUBLIC_ASSET__5dc338cd__"